import * as React from "react";

function MahleIcon(props) {
  const { className, height, width } = props;

  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 91 28"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M 20.41785,21.997559 H 16.314335 V 11.287598 l -2.964844,6.950195 h -2.84668 L 7.5379677,11.287598 V 21.997559 H 3.6492958 V 6.0024414 h 4.7910156 l 3.5986326,8.0244136 3.587891,-8.0244136 h 4.791015 z m 19.303282,0 H 35.456484 L 34.350039,18.76416 h -5.929688 l -1.106445,3.233399 H 23.156679 L 29.064882,6.0024414 h 4.748047 z m -6.370117,-6.166016 -1.96582,-5.736328 -1.965821,5.736328 z m 23.449766,6.166016 h -4.125 v -7.046875 h -6.09082 v 7.046875 h -4.125 V 6.0024414 h 4.125 v 5.8544926 h 6.09082 V 6.0024414 h 4.125 z m 16.05914,0 H 61.322811 V 6.0024414 h 4.125 V 18.903809 h 7.41211 z m 14.490783,0 H 75.781368 V 6.0024414 h 11.569336 v 3.09375 h -7.46582 v 2.7607426 h 6.928711 v 3.09375 h -6.928711 v 3.953125 h 7.46582 z"
        fill="2754cc"
        aria-label="MAHLE"
      />
    </svg>
  );
}

export default MahleIcon;
